/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relative Synonymous Codon Usage is the ratio of a codon's observed frequency to its expected frequency under equal synonymous usage. It reveals codon preference independent of amino-acid content.`)
};

const es_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Uso Relativo de Codones Sinónimos es la razón entre la frecuencia observada de un codón y su frecuencia esperada bajo un uso sinónimo igualitario. Revela la preferencia de codones independientemente del contenido de aminoácidos.`)
};

const de_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Relative Synonyme Codon-Nutzung ist das Verhältnis der beobachteten Häufigkeit eines Codons zu seiner erwarteten Häufigkeit bei gleicher synonymer Nutzung. Sie zeigt die Codon-Präferenz unabhängig vom Aminosäuregehalt.`)
};

const nl_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relative Synonymous Codon Usage is de verhouding tussen de waargenomen frequentie van een codon en de verwachte frequentie bij gelijk synoniem gebruik. Het toont codonvoorkeur onafhankelijk van de aminozuursamenstelling.`)
};

const fr_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'usage relatif des codons synonymes est le rapport entre la fréquence observée d'un codon et sa fréquence attendue sous usage synonyme égal. Il révèle la préférence de codon indépendamment du contenu en acides aminés.`)
};

const it_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'uso relativo dei codoni sinonimi è il rapporto tra la frequenza osservata di un codone e la sua frequenza attesa con un uso sinonimo uguale. Rivela la preferenza dei codoni indipendentemente dal contenuto amminoacidico.`)
};

const pt_br2_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Uso Relativo de Códons Sinônimos é a razão entre a frequência observada de um códon e sua frequência esperada sob uso sinônimo igualitário. Ele revela a preferência de códons independentemente do conteúdo de aminoácidos.`)
};

const pt_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Uso Relativo de Codões Sinónimos é o rácio entre a frequência observada de um codão e a sua frequência esperada num uso sinónimo equitativo. Revela a preferência por codões independentemente do conteúdo em aminoácidos.`)
};

const ja_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相対同義コドン使用頻度とは、あるコドンの実際の頻度と、同義コドンが均等に使われた場合の期待頻度との比率です。アミノ酸組成とは独立にコドンの選好性を明らかにします。`)
};

const zh_rscu_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相对同义密码子使用度是某密码子实际观测频率与假设同义密码子均等使用时预期频率之比。它揭示了独立于氨基酸组成的密码子偏好性。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_faq_a1", locale)
	if (locale === "en") return en_rscu_faq_a1(inputs)
	if (locale === "es") return es_rscu_faq_a1(inputs)
	if (locale === "de") return de_rscu_faq_a1(inputs)
	if (locale === "nl") return nl_rscu_faq_a1(inputs)
	if (locale === "fr") return fr_rscu_faq_a1(inputs)
	if (locale === "it") return it_rscu_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_faq_a1(inputs)
	if (locale === "pt") return pt_rscu_faq_a1(inputs)
	if (locale === "ja") return ja_rscu_faq_a1(inputs)
	return zh_rscu_faq_a1(inputs)
};